import type { PickerUserOrGroup } from './types.tsx';

export const getFilteredUsers = (users: PickerUserOrGroup[]) =>
	users.filter(({ accountType }) => accountType !== 'customer');
